module.exports = __webpack_public_path__ + "static/designer-8b11949b45ea8ec415945ebd8ca55344.png";